import React, { useEffect } from "react";
import "./favourites.css";
import { UserStore } from "../store/store";
import Anchor from "../Link/anchor";
import Global from "../../global";
import { favourited, getPercentage, newFavourites } from "../javascript/function";
import SectionHeader from "../sectionHeader/sectionHeader";
import NotFound from "../notfound/notfound";
import LazyImg from "../lazy/lazy";

const FavouriteList = (props) => {
  const currentUser = UserStore.useState((s) => s.user);

  useEffect(() => {}, []);
  return (
    <div style={{ paddingTop: "100px" }}>
      <SectionHeader
        title={currentUser.FAVOURITES !== null || currentUser.FAVOURITES.length!==0 ?"":"Favourites"}
        linkTitle={""}
        link={""}
        header={true}
      ></SectionHeader>
      <div className="landscapeList favourite">
        <div className="container-fluid ">
          {currentUser.FAVOURITES !== null && currentUser.FAVOURITES.length!==0
            ? currentUser.FAVOURITES.map((item, index) => (
                <div className="list-item" key={index}>
                  <Anchor className={Global.BORDER?"slide-one slide-two":"slide-one slide-two no-border"} to={item.type==="video"?"/"+props.match.params.AppId+"/videoPage/"+item.videoId:"/"+props.match.params.AppId+"/page/"+item.videoId}>
                    <div
                      className="slide-image"
                    >
                      <LazyImg src={item.imageUrl} style={{position:'absolute',height:'100%',width:'100%'}} orient={"landscape"}/>
                    </div>
                    <div className={"slide-content showed"}>
                      <h2>
                        {item.title}
                        {Global.FAVOURITES ? (
                          <span
                            className="span"
                            onClick={(event) => {
                              newFavourites(event, item, "page");
                            }}
                          >
                            {" "}
                            <i
                              className={
                                favourited(item.videoId, currentUser.FAVOURITES)
                                  ? "ri-check-fill"
                                  : "ri-add-line"
                              }
                            ></i>
                          </span>
                        ) : (
                          ""
                        )}
                      </h2>
                    </div>
                    <div className="cwwrapper transparent"><div className="cwprogress" style={{width: item.type==="video"?getPercentage(item.videoId,currentUser.WATCHHISTORY)+"%":"0%"}}></div></div>
                  </Anchor>
                </div>
              ))
            :<NotFound   code={"Favourites"}
            message={"No Data to Show"} {...props}></NotFound>}
        </div>
      </div>
    </div>
  );
};

export default FavouriteList;
